<template>
  <div class="job-category">
    <v-row>
      <v-col cols="4">
        <v-select 
          v-model="search.device_status" 
          :items="deviceStatus"
          item-text="label"
          item-value="value"
          label="Device State"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.organisation" label="Organisation"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.vehicle_name" label="Vehicle"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field v-model="search.install_tag" label="Install Tag"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.imei" :rules="imeiRules" type="number" label="IMEI"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.otc" :rules="otcRules" type="number" label="OTC"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8">
        <v-select 
          v-model="search.model" 
          :items="models"
          item-text="label"
          item-value="value"
          label="Model"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-text-field v-model="search.firmware_version" label="Firmware Version"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-select 
          v-model="search.disabled" 
          :items="state"
          item-text="label"
          item-value="value"
          label="Enabled/Disabled"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-select 
          v-model="search.is_default" 
          :items="deviceClass"
          item-text="label"
          item-value="value"
          label="Device Class"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { Logger } from "aws-amplify"
import { pageCache } from '@/mixins/page-cache.js';
const logger = new Logger("Advanced Search / Vehicles")

export default {
  name: 'Jobs',
  mixins: [
    pageCache('globalsearchdevices')
  ],
  props: {
    reset: {
      type: Number,
      required: true
    }
  },
  
  data() {
    return {
      searching: false,
      deviceStatus: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Assigned',
          value: 'assigned'
        },
        {
          label: 'Unassigned',
          value: 'unassigned'
        },
        {
          label: 'Pending',
          value: 'pending'
        },
        {
          label: 'Unknown',
          value: 'unknown'
        }
      ],
      models: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'CAMERAMATICS_JH8_NT-HD-4G (NextGen 8CH)',
          value: 'CAMERAMATICS_JH8_NT-HD-4G'
        },
        {
          label: 'CAMERAMATICS_JH4_NT-HD-4G (NextGen 4CH)',
          value: 'CAMERAMATICS_JH4_NT-HD-4G'
        },
        {
          label: 'CAMERAMATICS_D700_SD-4G (Genie Dashcam)',
          value: 'CAMERAMATICS_D700-SD-4G'
        },
        {
          label: 'CAMERAMATICS_JI7A_SD-4G (Genie 2 Dashcam)',
          value: 'CAMERAMATICS_JI7A-SD-4G'
        },
        {
          label: 'CAMERAMATICS_JH8_HD-4G (Legacy 8CH)',
          value: 'CAMERAMATICS_JH8-HD-4G'
        },
        {
          label: 'CAMERAMATICS_JH4_HD-4G (Legacy 4CH)',
          value: 'CAMERAMATICS_JH4-HD-4G'
        }
      ],
      state: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Enabled',
          value: 'False'
        },
        {
          label: 'Disabled',
          value: 'True'
        }
      ],
      deviceClass: [
        {
          label: 'All',
          value: ''
        },
        {
          label: 'Primary',
          value: 'True'
        },
        {
          label: 'Secondary',
          value: 'False'
        }
      ],
      search: {
        device_status: '',
        vehicle_name: '',
        organisation : '',
        install_tag: '',
        imei: '',
        otc: '',
        model: '',
        firmware_version: '',
        disabled: '',
        is_default: ''
      }
    }
  },
  computed: {
    imeiRules() {
      return [
        v => v.length <= 15 || 'Max 15 characters'
      ]
    },
    otcRules() {
      return [
        v => v.length <= 15 || 'Max 15 characters'
      ]
    }
  },
  watch: {
    search: {
      handler(val) {
        this.$emit('updatedSearchCriteria', val)
      },
      deep: true
    },
    reset() {
      this.resetFields();
    }
  },
  mounted() {
    this.search.device_status = '';
    this.search.model = '';
    this.search.disabled = '';
    this.search.is_default = '';
  },
  methods: {
    resetFields() {
      logger.info('clear them fields')

      for (var key in this.search) {
        if (this.search.hasOwnProperty(key)) {
          this.search[key] = '';
        }
      }
    }
  }
}
</script>